import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

import type { SortableHeaderProps } from '../types';
import type { RowData } from '@tanstack/react-table';

import { Button } from '@/components/ui/button';

export const SortableHeader = <TData extends RowData, TValue>(
  props: SortableHeaderProps<TData, TValue>,
) => {
  const { column, children } = props;
  const sorted = column.getIsSorted();

  return (
    <Button
      variant="ghost"
      onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
      className="h-auto p-0 font-medium uppercase hover:bg-transparent"
    >
      {children}
      {sorted === 'asc' && <ArrowUp className="ml-2 size-4" />}
      {sorted === 'desc' && <ArrowDown className="ml-2 size-4" />}
      {!sorted && <ArrowUpDown className="ml-2 size-4 opacity-50" />}
    </Button>
  );
};
